import { combineReducers } from 'redux';
import { cart } from './Reducers/Cart.reducer';
import { compare } from './Reducers/Compare.reducer';
import { quickSearch } from './Reducers/QuickSearch.reducer';
import { navigation } from './Reducers/Navigation.reducer';
import { facetedSearch } from './Reducers/FacetedSearch.reducer';
import { checkout } from './Reducers/Checkout.reducer';
import { myPage } from './Reducers/MyPage.reducer';
import { dealerInfo } from './Reducers/DealerInfo.reducer';
import { findMyPart } from './Reducers/FindMyPart.reducer';
import { languageSelector } from './Reducers/LanguageSelector.reducer';
import { library } from './Reducers/Library.reducer';
import { quickOrder } from './Reducers/QuickOrder.reducer';
import { springCalc } from './Reducers/SpringCalc.reducer';

const staticReducers = {
  cart,
  quickSearch,
  navigation,
  facetedSearch,
  checkout,
  myPage,
  dealerInfo,
  findMyPart,
  languageSelector,
  library,
  quickOrder,
  compare,
  springCalc,
};

const app = combineReducers(staticReducers);

export const createReducer = (asyncReducers) => {
  return combineReducers({
    ...staticReducers,
    ...asyncReducers,
  });
};

export default app;
